var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.featureEnabled('formula_field'))?_c('formula-field-configurator',{attrs:{"configuration":_vm.configuration,"field-name":_vm.fieldName}}):_c('feature-disabled-alert',{attrs:{"feature":"formula_field"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }